<template>
  <div v-show="active">
    <UsersTable
      v-if="keepAlive"
      ref="users"
      reference="usersBlockedTable"
      namespace="users?is_blocked=true"
      :groups="groups"
      @delete="$emit('delete', $event)"
      @edit="$emit('edit', $event)"
    />
  </div>
</template>

<script>
import UsersTable from "./UsersTable.vue";

export default {
  name: "UsersBlocked",
  props: {
    groups: {
      type: Array,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      keepAlive: false,
    };
  },
  watch: {
    active(newValue) {
      if (newValue && !this.keepAlive) {
        this.keepAlive = true;
      }
    },
  },
  components: {
    UsersTable,
  },
  methods: {
    loadData() {
      this.$refs.users?.getData();
    },
  },
  activated() {},
};
</script>
